module.exports = __webpack_public_path__ + "img/code.046542c7.png";